import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import AGentleGoodbye from "./sections/AGentleGoodbye";
import TheCompetitiveEdge from "./sections/TheCompetitiveEdge";
import ExpertCareServices from "./sections/ExpertCareServices";
import TheOpportunity from "./sections/TheOpportunity";
import ReadyForYourFitting from "./sections/ReadyForYourFitting";
import StudioFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <AGentleGoodbye />
      <TheCompetitiveEdge />
      <ExpertCareServices />
      <TheOpportunity />
      <ReadyForYourFitting />
      <StudioFooter />
    </div>;
}